import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import { SearchProvider } from "@/context/SearchContext";

export default function AppLayout() {
  return (
    <SearchProvider>
      <div className="min-h-screen bg-bg relative z-10">
        <Header />
        <main className="max-w-[1400px] mx-auto px-5 py-8">
          <Outlet />
        </main>
      </div>
    </SearchProvider>
  );
}
